import * as React from "react"
const SvgTextItalic = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7.25 19.286q-.525 0-.888-.363A1.2 1.2 0 0 1 6 18.036q0-.525.362-.888a1.2 1.2 0 0 1 .888-.362H10l3-9h-2.75q-.525 0-.887-.363A1.2 1.2 0 0 1 9 6.536q0-.525.363-.888.362-.362.887-.362h7.5q.525 0 .887.362.363.363.363.888c0 .525-.12.646-.363.887a1.2 1.2 0 0 1-.887.363H15.5l-3 9h2.25q.525 0 .887.362.363.363.363.888c0 .525-.12.646-.363.887a1.2 1.2 0 0 1-.887.363z" />
  </svg>
)
export default SvgTextItalic
